export function getLocalDateStr(offsetDays = 0) {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export const MEETING_STATUS_COLORS = {
  scheduled:   { bg: 'var(--color-info-light, #EFF6FF)', color: 'var(--color-info-dark, #2563EB)' },
  confirmed:   { bg: 'var(--color-success-light, #F0FDF4)', color: 'var(--color-success-dark, #16A34A)' },
  in_progress: { bg: 'var(--color-warning-light, #FFF7ED)', color: 'var(--color-warning-dark, #EA580C)' },
  completed:   { bg: 'var(--color-success-light, #ECFDF5)', color: 'var(--color-success-dark, #059669)' },
  cancelled:   { bg: 'var(--color-danger-light, #FEF2F2)', color: 'var(--color-danger-dark, #DC2626)' },
  no_show:     { bg: 'var(--color-surface-alt, #F3F4F6)', color: 'var(--color-text-secondary, #6B7280)' },
};

export function resolveClientName(meeting, clientMap = {}) {
  if (!meeting) return '';
  return meeting.clientName
    || meeting.studentName
    || clientMap[meeting.transplantClientId]
    || clientMap[meeting.studentId]
    || '';
}

export function composeSectionsText(sections = []) {
  return sections
    .map((s) => {
      const header = (s.header || '').trim();
      const content = (s.content || '').trim();
      if (header && content) return `${header}:\n${content}`;
      return header ? `${header}:` : content;
    })
    .filter(Boolean)
    .join('\n\n');
}
